// Components
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"

// Screens
import History from "./history"
import Stocks from "./stocks"

export default function Stock(){
    return(
    <Tabs isLazy size="sm" variant="solid-rounded" colorScheme="orange">
        <TabList>
            <Tab>Visão Geral do Estoque</Tab>
            <Tab>Histórico</Tab>
        </TabList>
        <TabPanels>
            <TabPanel><Stocks /></TabPanel>
            <TabPanel><History /></TabPanel>
        </TabPanels>
    </Tabs>   
    )
}